export default __webpack_public_path__ + "static/B34-25fbc72e904d5cf555bd30c5e933c213.png";